<script>
    export default {
        inserted: function(el) {
            const calculate = function(el) {
                var max_height = 0;
                $('.item', el).height('unset')
                $('.item', el).each(function(e, f, g) {
                    max_height = ($(this).height() > max_height) ? $(this).height() : max_height
                }).height(max_height);
            }
            setTimeout(() => {
                calculate(el)
            }, 1000);
            $(window).resize(() => calculate(el));
        }
    }
</script>